import { useaxios } from "../../../../utils/useaxios";
export default (from, to) => initDispatch => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    useaxios('company_income/read.php', { from, to }).then((res) => {
        console.log(res);
        if (res.status == "ok") {
            initDispatch({ type: 'setincome', payload: res.incomes });
        } else {
            // clear();
        }
        // setloading(false);
    });
}